/**
 * This component will inherit GiftTile UI
 * and add logic for the message.
 */
import GiftTile from '3-components/GiftTile/GiftTile';
import { useDonationStore } from '../libs/useDonationStore';
import { useDonationBlockProps } from '../DonationBlockProvider';
import type { FC } from 'react';

interface DonationGiftTileProps {
    showImage?: boolean;
}

/**
 * message rules:
 * - number of people impacted is round down.
 * - 1 person => show 1 person message
 * - less than 1 person => show low message
 * - more than 10 person => show high message
 */

const DonationGiftTile: FC<DonationGiftTileProps> = props => {
    const { showImage = false } = props;

    const { giftTileSettings } = useDonationBlockProps();
    const { donationData, getTotalAmount } = useDonationStore();

    if (!giftTileSettings?.enable) {
        return null;
    }

    const { amount, frequency } = donationData;
    const totalAmount = getTotalAmount();

    const { message, baseAmount, imageUrl } = giftTileSettings;

    const divider = baseAmount ?? 25;

    const numberPeopleImpacted = Math.floor(amount / divider);

    let giftMessage = '';

    if (numberPeopleImpacted === 1) {
        giftMessage = message.singlePerson[frequency];
    } else if (numberPeopleImpacted > 10) {
        giftMessage = message.highNumber[frequency];
    } else if (numberPeopleImpacted < 1) {
        giftMessage = message.lowNumber[frequency];
    } else {
        giftMessage = message.general[frequency];
    }

    // replace placeholder character with related data
    giftMessage = giftMessage.replace('[$]', `$${(totalAmount % 1 !== 0) ? totalAmount.toFixed(2) : totalAmount}`).replace('[#]', numberPeopleImpacted.toString());

    const imgSource = showImage ? imageUrl : '';

    return (
        <GiftTile
            img={{ imgSrc: imgSource, imgAlt: `Gift tile image` }}
            title={giftMessage}
        />
    );
};

export default DonationGiftTile;
